import { useAuth0 } from '@auth0/auth0-react'
import Cookies from 'js-cookie'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import Swal from 'sweetalert2'

import type { RootState } from '@/store'
import { apiService, useLazyClearSessionQuery } from '@/store/apiService'
import { setIsMultiSession } from '@/store/appSlice'

interface AppState {
  isMultiSession: boolean
}

const ErrorPage = () => {
  const [searchParams] = useSearchParams()
  const dispatch = useDispatch()
  const code = searchParams.get('code')
  const errorCode = searchParams.get('code')
  const sessionId = Cookies.get('session_id')

  const { isMultiSession } = useSelector<RootState, AppState>(
    (state) => state.app,
  )

  const { getIdTokenClaims } = useAuth0()

  const [clearSession] = useLazyClearSessionQuery()
  useEffect(() => {
    if (isMultiSession) {
      getIdTokenClaims()
        .then(() => {
          clearSession('multi', false)
            .unwrap()
            .then(() => {
              dispatch(setIsMultiSession(false))
              dispatch(
                apiService.util.invalidateTags([
                  { type: 'Recipes', id: 'LIST' },
                ]),
              )
              setTimeout(() => {
                window.location.href = '/'
              }, 200)
            })
            .catch((error) => {
              console.error('Failed to clear session:', error)
            })
        })
        .catch((error) => {
          console.error('Failed to get ID token claims:', error)
        })
    } else if (code === '551') {
      Swal.fire({
        title: 'We&rsquo;ll be back soon!',
        text: "Sorry for the inconvenience but we're performing some maintenance at the moment. If you need to you can always contact us at info@matisse.ai, otherwise we'll be back online shortly!",
        icon: 'warning',
        allowOutsideClick: false,
      })
    }
  }, [sessionId, errorCode, clearSession, dispatch, isMultiSession, code])

  return null
}

export default ErrorPage
